import { compose } from 'recompose';
import { connect } from 'react-redux';

import CancelForm from 'components/ModalCancelOrder/Sections/CancelForm/component';
import { selectors as uiSelectors } from 'state/ui';
import { actions as ordersActions } from 'state/orders';

const enhance = compose(
  connect(
    (state) => ({
      order: uiSelectors.isCancelOrderModalOpened(state),
    }),
    {
      cancelOrder: ordersActions.cancelOrder,
    }
  )
);

export default enhance(CancelForm);
